/* 🤖 this file was generated by svg-to-ts */
export const iconSearch32: {
  name: 'search_32';
  data: string;
} = {
  name: 'search_32',
  data: `<svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M2,13.5 C2,7.159 7.159,2 13.5,2 C19.841,2 25,7.159 25,13.5 C25,19.841 19.841,25 13.5,25 C7.159,25 2,19.841 2,13.5 M0,13.5 C0,20.944 6.056,27 13.5,27 C16.863,27 19.935,25.756 22.301,23.715 L30.293,31.707 C30.488,31.902 30.744,32 31,32 C31.256,32 31.512,31.902 31.707,31.707 C32.098,31.316 32.098,30.684 31.707,30.293 L23.715,22.301 C25.756,19.935 27,16.863 27,13.5 C27,6.056 20.944,0 13.5,0 C6.056,0 0,6.056 0,13.5"/></svg>`,
};
